import { type } from 'os';
import React, { useState } from 'react'


export interface CircularButtonProps {
  type: 'primary' | 'secondary' | 'highlight'
  Icon: any,
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  className?: string
}
const CircularButton: React.FC<CircularButtonProps> = (props) => {
  const {
    Icon,
    type,
    onClick,
    className
  } = props;

  let classList = [
    "transform transition-transform inline-block w-12 h-12 rounded-full flex justify-center items-center shadow-xl hover:scale-110"
  ];

  if (type === 'secondary') classList.push('bg-secondary');
  if (type === 'highlight') classList.push('bg-highlight-yellow');
  if(className) classList.push(className)

  return (
    <button className={classList.join(' ')} onClick={onClick}>
      {Icon}
    </button>
  );
}

CircularButton.defaultProps = {
  type: 'primary'
}


export default CircularButton;